import { createSelector } from 'reselect'
import { get } from 'lodash/fp'
import { Selector } from '../types/common'
import { IPublishedMessage } from '../types/message'
import { IInternalMessagesState } from './internalMessagesReducer'

export const internalMessagesRootSelector: Selector<IInternalMessagesState> =
  get('internalMessages')

export const publishedMessageSelector = createSelector(
  internalMessagesRootSelector,
  (root) => root.publishedMessage,
)
